// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getSiteFeatureById } from 'app/constants/enums/SiteFeature/main';

/* eslint-disable max-len */
export const DAILY_NEWS = getSiteFeatureById('dailyNews');
export const IKNOW_INTEGRATION = getSiteFeatureById('iknowIntegration');
export const MATERIALS = getSiteFeatureById('materials');
export const MEETINGS = getSiteFeatureById('meetings');
export const USERS = getSiteFeatureById('users');
export const WORDS_PAGE = getSiteFeatureById('wordsPage');
/* eslint-enable max-len */
